{
  "OrganizationTalentsPage": {
    "title": "Organization talents"
  },
  "ResourceTypesSettingsMenu": {
    "triggerLabel": "Configure resource types",
    "heading": "Configure resource types",
    "allTypes": "All types",
    "global": "In this organization",
    "workspace": "In this workspace",
    "thisTypeInWorkspace": "{{name}} in this workspace"
  },
  "ResourceRowGallery": {
    "failedToLoad": "Failed to load pins",
    "empty": "No pins yet",
    "addContactPins": "Add pins",
    "label": "Pins"
  },
  "AssignResourcesToWorkspacesDialog": {
    "title": "Assign to workspaces",
    "description_one": "Choose how {{name}} is visible across workspaces.",
    "description_other": "Choose how these {{count}} resources are visible across workspaces.",
    "fieldScope": "Visibility",
    "scopeHidden": "Hidden",
    "scopeHiddenHint": "No workspace membership — not listed anywhere (admin-only).",
    "scopeGlobal": "Global",
    "scopeGlobalHint": "Visible in every workspace (membership with no workspace id).",
    "scopeWorkspaces": "Specific workspaces",
    "fieldWorkspaces": "Workspaces",
    "workspacesSelectPrompt": "Select one or more workspaces",
    "workspacesSelectedCount": "{{count}} selected",
    "workspacesUnselectAll": "Unselect all",
    "workspacesEmpty": "No workspaces available",
    "save": "Assign",
    "assignFailed": "Failed to assign workspaces",
    "unsavedChangesBeforeUnload": "You have unsaved changes!",
    "success_one": "Resource assigned to workspaces",
    "success_other": "{{count}} resources assigned to workspaces"
  },
  "ResourceWorkspacesCell": {
    "hidden": "Hidden",
    "global": "Global"
  },
  "ResourceCreateForm": {
    "profilePicture": "Profile picture",
    "resourceType": "Resource type"
  },
  "ResourceCreateDialog": {
    "title": "Create resource",
    "titleTypeAndVisibility": "Create resource · type & visibility",
    "titleType": "Create resource · type",
    "titleDetails": "Create resource · details",
    "description": "Create a new resource",
    "actions": {
      "add-another": "Save & add another",
      "go-to-profile": "Save & go to profile",
      "close": "Save"
    },
    "createFailed": "Failed to create resource",
    "noResourceTypes": "No resource types are available."
  },
  "CreateDraftSummary": {
    "change": "Change"
  },
  "ResourceDuplicatesFooter": {
    "title": "Looks familiar?",
    "titleExact": "Someone with this name already exists",
    "summary_one": "{{count}} existing resource has a similar name",
    "summary_other": "{{count}} existing resources have a similar name",
    "summaryNamed_one": "{{count}} existing resource looks like “{{name}}”",
    "summaryNamed_other": "{{count}} existing resources look like “{{name}}”",
    "review": "Review",
    "hide": "Hide",
    "dismiss": "Dismiss",
    "exactMatch": "Same name",
    "similarMatch": "Similar",
    "openProfile": "Open",
    "openProfileOf": "Open the profile of {{name}} in a new tab",
    "hint": "Profiles open in a new tab, so your draft stays here. Different person? Just save."
  },
  "ResourceSchema": {
    "coreLabel": {
      "fullName": "Full name",
      "pronouns": "Pronouns",
      "emails": "Email Addresses",
      "phoneNumbers": "Phone Numbers",
      "socials": "Social Media",
      "websites": "Websites",
      "tags": "Tags",
      "groups": "Groups",
      "locations": "Locations",
      "rates": "Rates",
      "agent": "Agent",
      "organization": "Organization",
      "nickname": "Nickname",
      "role": "Role"
    },
    "enterPlaceholder": "Enter {{label}}",
    "globalSection": "Global",
    "emptyWorkspaceSection": "No fields specific to {{workspaceName}}",
    "locationItemTitle": "Location",
    "rateItemTitle": "Rate",
    "addRate": "Add rate",
    "blankRate": "Blank rate",
    "blankRateHint": "Type the amount",
    "fromRateCard": "From rate card",
    "addItem": "Add {{name}}"
  },
  "ResourceEditorVersionSwitch": {
    "title": "Resource editor",
    "newVersionDescription": "You're trying the new editor. It's still experimental — if something looks off, switch back. Your data stays the same.",
    "oldVersionDescription": "You're on the classic editor. The new one is in beta — give it a go anytime."
  },
  "ResourceNotesPanel": {
    "title": "Notes",
    "fieldLabel": "New note",
    "placeholder": "Write a note…",
    "submit": "Add note",
    "emptyTitle": "No notes yet",
    "emptyDescription": "Write notes about {{name}}.",
    "fallbackName": "this resource",
    "loadError": "Could not load notes.",
    "unknownUser": "Unknown user",
    "deleteAria": "Remove note",
    "createdToast": "Note added",
    "createErrorToast": "Could not add note",
    "deletedToast": "Note removed",
    "deleteErrorToast": "Could not remove note"
  },
  "ResourceFilesPanel": {
    "title": "Documents",
    "emptyTitle": "No documents yet",
    "emptyDescription": "Keep track of important documents and files for {{name}}.",
    "fallbackName": "this resource",
    "loadError": "Could not load documents.",
    "untitled": "Untitled file",
    "uploadedToast": "File uploaded",
    "uploadErrorToast": "Upload failed",
    "reorderErrorToast": "Could not save the new order"
  },
  "ResourcePane": {
    "invalidDataDescription": "We're showing this form anyway, but it may not work correctly. If you run into problems, contact support."
  },
  "Pinboard": {
    "title": "Pinboard",
    "addPins": "Add pins",
    "filterByTag": "Filter by tag",
    "tags": "Tags",
    "countFiltered_one": "{{count}} of {{total}} pins",
    "countFiltered_other": "{{count}} of {{total}} pins",
    "noMatchesTitle": "No pins match these tags",
    "noMatches": "Try other tags, or clear the filter to see every pin.",
    "emptyReadOnly": "Pins highlight examples of work and important information about the person.",
    "loading": "Loading pins",
    "toast": {
      "undo": "Undo",
      "added": "Pin added",
      "addFailed": "Could not add the pin",
      "addedMany_one": "Pin added",
      "addedMany_other": "{{count}} pins added",
      "addedPartly": "{{added}} added, {{failed}} failed",
      "addFailedMany_one": "Could not add the pin",
      "addFailedMany_other": "Could not add {{count}} pins",
      "deleted_one": "Pin deleted",
      "deleted_other": "{{count}} pins deleted",
      "deleteFailed_one": "Could not delete the pin",
      "deleteFailed_other": "Could not delete {{count}} pins",
      "updated": "Pin updated",
      "updateFailed": "Could not update the pin",
      "profilePictureSaved": "Profile picture saved",
      "profilePictureFailed": "Could not set the profile picture",
      "reorderFailed": "Could not save the new order"
    },
    "card": {
      "untitled": "Untitled",
      "actions": "Actions for {{name}}",
      "editTags": "Edit tags",
      "setAsProfilePicture": "Set as profile picture",
      "download": "Download",
      "openLink": "Open link",
      "delete": "Delete pin"
    },
    "add": {
      "title": "Add pins",
      "description": "Pictures, videos, documents and links, shown on the pinboard.",
      "formats": "Pictures, videos, PDFs and other files · paste with ⌘V",
      "orAddLink": "Or add a link"
    },
    "link": {
      "hint": "A picture, a YouTube or Vimeo video, or any web page.",
      "notAUrl": "Not a link",
      "notAUrlHint": "Paste an address such as https://example.com/photo.jpg.",
      "brokenPicture": "The picture didn't load",
      "brokenPictureHint": "Check the address, or download the picture and upload it.",
      "missingVideo": "The video wasn't found",
      "missingVideoHint": "Check that the video exists and is public.",
      "page": "A web page"
    },
    "pin": "pin",
    "pins": "pins",
    "deleteSelected_one": "Delete {{count}} pin",
    "deleteSelected_other": "Delete {{count}} pins"
  },
  "ResourceAside": {
    "title": "Overview",
    "expand": "Expand panel",
    "collapse": "Collapse panel",
    "fallbackName": "this resource",
    "heroNow": "Now: {{status}}",
    "heroUntil": "until {{date}}",
    "heroNext": "Next: {{status}}",
    "heroEmpty": "Nothing scheduled",
    "heroEmptyDetail_one": "The next {{count}} day is empty",
    "heroEmptyDetail_other": "The next {{count}} days are empty",
    "startsTomorrow": "Tomorrow",
    "startsInDays_one": "in {{count}} day",
    "startsInDays_other": "in {{count}} days",
    "scheduleTitle": "Schedule",
    "scheduleAdd": "Add availability",
    "scheduleNow": "Now",
    "scheduleEmpty": "Note when {{name}} is next available.",
    "scheduleCalendar": "Open calendar",
    "scheduleCalendarMore_one": "Open calendar · {{count}} more",
    "scheduleCalendarMore_other": "Open calendar · {{count}} more",
    "shortlistsTitle": "Shortlists",
    "shortlistsAdd": "Add to shortlist",
    "shortlistsMenu": "Shortlist actions",
    "shortlistsRemove": "Remove from shortlist",
    "shortlistsEmpty": "Shortlists {{name}} is added to will appear here.",
    "shortlistsError": "Couldn't load shortlists.",
    "previewError": "Couldn't load.",
    "notesTitle": "Notes",
    "notesEmpty": "No notes about {{name}} yet.",
    "notesOpen": "Open notes",
    "documentsTitle": "Documents",
    "documentsEmpty": "No documents for {{name}} yet.",
    "documentsOpen": "Open documents",
    "untitledFile": "Untitled file",
    "shortlistPublished": "Published",
    "shortlistDraft": "Draft",
    "shortlistCount": "{{count}} shortlisted"
  },
  "ContactPeopleList": {
    "title": "People",
    "addResources": "Add resources",
    "addFirst": "Add the first person",
    "emptyTitle": "No people yet",
    "noMatchTitle": "No people found",
    "emptyMessageOrganisation": "Add the people who work for this organisation.",
    "emptyMessageAgent": "Add the people this agent represents.",
    "removeFromOrganisation": "Remove from organisation",
    "removeFromAgent": "Remove from agent",
    "confirmOrganisation": "Remove the selected people from this organisation? They stay in your contacts.",
    "confirmAgent": "Remove the selected people from this agent? They stay in your contacts.",
    "confirmRemove": "Remove",
    "removedToast": "Removed {{count}}.",
    "removedPartialToast": "Removed {{removed}}. {{notLinked}} were not linked here and were left as they are.",
    "removeFailedToast": "Could not remove the selected people"
  },
  "ContactPeopleAddResources": {
    "title": "Add resources",
    "pick": "Pick for {{name}}",
    "linked": "Already linked",
    "noResults": "No resources found",
    "noLinkableTypes": "No resource type here can be linked to {{name}}.",
    "add": "Add to {{name}}",
    "added_one": "Added {{count}} person to {{name}}",
    "added_other": "Added {{count}} people to {{name}}",
    "addFailed": "Couldn’t add everyone to {{name}}. Try again."
  }
}
